import React from "react";
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { getFormValues, change } from "redux-form";

import { AI_GENERATE_VERSIONS_FORM } from "./constants";
import { getDisplayData } from "selectors/AI";

import VariationPreview from "./VariationPreview";
import {
	findVariation,
	addSelectedVersion,
	removeSelectedVersion
} from "./utils";

export default function PreviewGroup(props){
	const {
		name,
		variables,
		variationIndex,
	} = props;

	const dispatch = useDispatch();
	const displayData = useSelector(getDisplayData);

	const { versionNamePrefix, selectedVariations } = useSelector(getFormValues(AI_GENERATE_VERSIONS_FORM));
	const isAllSelected = displayData.every(data => findVariation(selectedVariations[data.creative.id]?.variations, variables));

	function handleSelectAll(event){
		const modifier = event?.target?.checked ? addSelectedVersion : removeSelectedVersion;
		const newSelections = displayData.reduce((prev, data) => {
			const creativeId = data?.creative?.id;
			return modifier(prev, creativeId, variables);
		}, selectedVariations);

		dispatch(change(AI_GENERATE_VERSIONS_FORM, "selectedVariations", newSelections));
	}

	const isSingleCreative = displayData.length === 1;
	const groupHeader = isSingleCreative ? null : (<div className="preview-group-title centered-row">
		<input
			id={name}
			type="checkbox"
			onChange={handleSelectAll}
			checked={isAllSelected}
		/>
		<label htmlFor={name}>{versionNamePrefix} {name}</label>
	</div>);

	const classes = classNames({
		"preview-group": true,
		"single-creative": isSingleCreative,
	});

	return (
		<div className={classes}>
			{groupHeader}
			<div className="preview-options">
				{displayData.map((data, index) => {
					const ftUtilsId = `place_${data.creative.id}_${variationIndex}_${index}`;

					return (
						<VariationPreview
							key={ftUtilsId}
							variationName={name}
							ftUtilsId={ftUtilsId}
							variationIndex={variationIndex}
							variables={variables}
							creativeId={data.creative.id}
						/>
					);
				})}
			</div>
		</div>
	);
}

PreviewGroup.displayName = "PreviewGroup";
